export const LiveWireRoutes = [
    {
        "url": "/live-wire-v2",
        "name": "appLayout.schedule.live-wire-v2",
        "type": "frontend",
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/live-wire/live-wire.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
    },
];
//# sourceMappingURL=live-wire.routes.js.map